export default __webpack_public_path__ + "static/24-ec7c091e179994ef3533c293417e4df2.png";